import AppModel from '@/models/AppModel'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  getApi: (bvModal, params = null, callbackSuccess = null, callbackFinally) => {
    return AppModel.get(
      'project/list',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }

        AppModel.validateStatus(res.data)

        if (callbackSuccess !== null) {
          callbackSuccess(res.data)
        }

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  }
  // postApi: (bvModal, params, callbackSuccess = null, callbackFinally) => {
  //   return AppModel.post(
  //     'delivered/complete',
  //     bvModal,
  //     params,
  //     (res) => {
  //       if (isDebug) {
  //         console.log(res.data)
  //       }

  //       AppModel.validateStatus(res.data)

  //       if (callbackSuccess !== null) {
  //         callbackSuccess(res.data)
  //       }

  //       return Promise.resolve(res.data)
  //     },
  //     callbackFinally
  //   )
  // }
}



// WEBPACK FOOTER //
// ./src/models/ProjectListModel.js